import { Chip, styled } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledChipBase = styled(Chip)(() => ({
  maxWidth: 'min-content',
}));

export const StyledChip = (props: ComponentProps<typeof StyledChipBase>) => (
  <StyledChipBase variant="outlined" color="secondary" {...props} />
);
